export enum CatalogID{
    METALWORKING= "MTA=",
    AIR_HAND_TOOLS= "NQ==",
    MACHAINE_TOOL_ACCESSORIES = "Ng==",
    PRECISION= "Nw==",
    SHEET_METAL_EUIPMENT= "OA==",
    SHOP_SAFETY_WEBDING= "OQ==",
    ABRASIVES_DIAMOND_TOOLS ="NA==",
    CUTTING_TOOLS_HSS_SOLID_CARBIDE= "Mw==",
    CUTTING_TOOLS_INDEXABLE_CARBIDE_TOOL_HOLDERS= "Njk=",
    DIAMOND_CBN_WHEELS= "MTE=",
    DRESSERS = "MTM="
}
export enum SubcategoryMetalworking{
    ABRASIVES_DIAMOND_TOOLS ="NA==",
    CUTTING_TOOLS_HSS_SOLID_CARBIDE= "Mw==",
    CUTTING_TOOLS_INDEXABLE_CARBIDE_TOOL_HOLDERS= "Njk="
}
export enum SubcategoryAbrasives{
    DIAMOND_CBN_WHEELS= "MTE=",
    DRESSERS = "MTM="
}
export enum CategoryName{
    END_MILLS= "End Mills",
    TURING_TOOL_HOLDERS = "Turning Tool Holders"
}
export enum CategoryNameChange{
    END_MILLS_CHANGE= "Indexable End Mills",
    TURING_TOOL_HOLDERS_CHANGE = "Indexable Turning Tool Holders"
}